import { appConfig } from "@/assets/scripts/js/AppConfig";
import { MockDb, mockDb } from "./MockDb";

export class MockApiService {
  isValidParam(param) {
    return param !== null && param !== "null" && param !== "undefined" && param !== "";
  }

  /* グループ設定 */
  filterUngroupRequests(params) {
    let list = mockDb.ungroupRequests.filter((item) => !item.groupId);

    const requesterIds = params.get("requesterIds");
    const shipDateFrom = params.get("shipDateFrom");
    const shipDateTo = params.get("shipDateTo");
    const departureLocationId = params.get("departureLocationId");
    const departureAreaId = params.get("departureAreaId");
    const arrivalLocationId = params.get("arrivalLocationId");
    const arrivalAreaId = params.get("arrivalAreaId");
    const carTypeId = params.get("carTypeId");
    const frameNumber = params.get("frameNumber");
    const importDate = params.get("importDate");
    const importUser = params.get("importUser");
    const sortBy = params.get("sortBy");
    const sortOrder = params.get("sortOrder");

    if (requesterIds.length > 0) {
      list = list.filter((item) => requesterIds.split(",").includes(item.requesterId.toString()));
    }

    if (this.isValidParam(shipDateFrom)) {
      list = list.filter((item) => item.shipDate >= shipDateFrom);
    }

    if (this.isValidParam(shipDateTo)) {
      list = list.filter((item) => item.shipDate <= shipDateTo);
    }

    if (this.isValidParam(departureLocationId)) {
      list = list.filter((item) => item.departureLocationId === departureLocationId);
    }

    if (this.isValidParam(departureAreaId)) {
      list = list.filter((item) => item.departureAreaId === departureAreaId);
    }

    if (this.isValidParam(arrivalLocationId)) {
      list = list.filter((item) => item.arrivalLocationId === arrivalLocationId);
    }

    if (this.isValidParam(arrivalAreaId)) {
      list = list.filter((item) => item.arrivalAreaId === arrivalAreaId);
    }

    if (this.isValidParam(carTypeId)) {
      list = list.filter((item) => item.carTypeId === carTypeId);
    }

    if (this.isValidParam(frameNumber)) {
      list = list.filter((item) =>
        item.frameNumber.toLowerCase().includes(frameNumber.toLowerCase())
      );
    }

    if (this.isValidParam(importDate)) {
      list = list.filter((item) => item.importDate === importDate);
    }

    if (this.isValidParam(importUser)) {
      list = list.filter((item) =>
        item.importUser.toLowerCase().includes(importUser.toLowerCase())
      );
    }

    if (this.isValidParam(sortBy)) {
      list.sort((a, b) => {
        if (a[sortBy] < b[sortBy]) return sortOrder === "DESC" ? 1 : -1;
        if (a[sortBy] > b[sortBy]) return sortOrder === "DESC" ? -1 : 1;
        return 0;
      });
    }

    return list;
  }

  /* グループ一覧 */
  filterGroups(params) {
    let list = mockDb.groups;

    const groupName = params.get("groupName");
    const statusId = params.get("statusId");
    const baseDateFrom = params.get("baseDateFrom");
    const baseDateTo = params.get("baseDateTo");
    const finalCalculationDateFrom = params.get("finalCalculationDateFrom");
    const finalCalculationDateTo = params.get("finalCalculationDateTo");
    const confirmDateFrom = params.get("confirmDateFrom");
    const confirmDateTo = params.get("confirmDateTo");
    const sortBy = params.get("sortBy");
    const sortOrder = params.get("sortOrder");

    if (this.isValidParam(groupName)) {
      list = list.filter((item) => item.groupName.includes(groupName));
    }

    if (this.isValidParam(statusId)) {
      list = list.filter((item) => item.statusId === statusId);
    }

    if (this.isValidParam(baseDateFrom)) {
      list = list.filter((item) => item.baseDate && item.baseDate >= baseDateFrom);
    }

    if (this.isValidParam(baseDateTo)) {
      list = list.filter((item) => item.baseDate && item.baseDate <= baseDateTo);
    }

    if (this.isValidParam(finalCalculationDateFrom)) {
      list = list.filter(
        (item) =>
          item.finalCalculationDateTime &&
          item.finalCalculationDateTime.substring(0, 10) >= finalCalculationDateFrom
      );
    }

    if (this.isValidParam(finalCalculationDateTo)) {
      list = list.filter(
        (item) =>
          item.finalCalculationDateTime &&
          item.finalCalculationDateTime.substring(0, 10) <= finalCalculationDateTo
      );
    }

    if (this.isValidParam(confirmDateFrom)) {
      list = list.filter((item) => item.confirmDate && item.confirmDate >= confirmDateFrom);
    }

    if (this.isValidParam(confirmDateTo)) {
      list = list.filter((item) => item.confirmDate && item.confirmDate <= confirmDateTo);
    }

    if (sortBy) {
      list.sort((a, b) => {
        if (a[sortBy] < b[sortBy]) return sortOrder === "DESC" ? 1 : -1;
        if (a[sortBy] > b[sortBy]) return sortOrder === "DESC" ? -1 : 1;
        return 0;
      });
    }

    return list.sort((a, b) => (a.requestNo < b.requestNo ? -1 : 1));
  }
  createCsvBlob(data) {
    const header = "Request Id,Request No,Detail No\n";
    const body = data.map((g) => `${g.requestId},${g.requestNo},${g.detailNo}`).join("\n");

    const csv = header + body;

    return new Blob([csv], { type: "text/csv;charset=utf-8;" });
  }

  async get(url) {
    const [path, queryString] = url.split("?");
    const params = new URLSearchParams(queryString || "");

    /* グループ設定の未グループ依頼 */
    if (path === appConfig.API_URL.BIZ_REQUESTS_UNGROUPED) {
      return this.filterUngroupRequests(params);
    }

    /* グループ一覧 */
    if (path === appConfig.API_URL.BIZ_GROUPS) {
      return this.filterGroups(params);
    }

    /* グループ一覧の納期/ルートデータダウンロード */
    let pattern = appConfig.API_URL.BIZ_GROUPS_DELIVERY_ROUTE_DATA_DOWNLOAD.replace(
      "{groupId}",
      "(\\d+)"
    );
    let match = url.match(new RegExp(`^${pattern}$`));
    if (match) {
      const groupId = Number(match[1]);
      // 確定済み以外ダインロードできない
      const index = mockDb.groups.findIndex(
        (item) => item.groupId === groupId && item.statusId === "3"
      );
      if (index === -1) {
        throw new Error("Bad Request");
      }

      const blob = this.createCsvBlob(
        mockDb.ungroupRequests.filter((item) => item.groupId === groupId)
      );

      return {
        data: blob,
        headers: {
          "content-type": "text/csv",
          "content-disposition": 'attachment; filename="groups.csv"',
        },
      };
    }

    throw new Error(`Unknown GET ${url}`);
  }

  async post(url, data) {
    const [path] = url.split("?");

    /* グループ設定 */
    if (path === appConfig.API_URL.BIZ_REQUESTS_GROUPING) {
      const requestIds = data.requestIds;
      const groupId = data.groupId;
      const groupName = data.groupName;
      const newGroupId = mockDb.nextId("groups");

      // 新しいグループに追加
      if (!groupId) {
        mockDb.groups.push({
          groupId: newGroupId,
          groupNo: `N0000${newGroupId}`,
          groupName: groupName,
          statusId: MockDb.STATUS_LIST[0].value,
          status: MockDb.STATUS_LIST[0].name,
          baseDate: "",
          finalCalculationDateTime: "",
          confirmDate: "",
          lastDownloadDate: "",
          lastGroupSettingUser: "〇〇〇〇",
          lastCalculationUser: "",
          lastDownloadUser: "",
        });
      }

      mockDb.ungroupRequests.forEach((item) => {
        if (requestIds.includes(item.requestId)) {
          item.select = false;
          item.groupId = !groupId ? newGroupId : groupId;
        }
      });
      return { success: true };
    }

    throw new Error("Unknown POST " + url);
  }

  async put(url) {
    /* グループ一覧の納期回答取消 */
    let pattern = appConfig.API_URL.BIZ_GROUPS_CANCEL_DELIVERY_RESPONSE.replace(
      "{groupId}",
      "(\\d+)"
    );
    let match = url.match(new RegExp(`^${pattern}$`));
    if (match) {
      const id = Number(match[1]);
      // 納期回答算出済みまたは確定済み以外納期回答取消できない
      const index = mockDb.groups.findIndex(
        (item) => item.groupId === id && (item.statusId === "2" || item.statusId === "3")
      );

      if (index === -1) {
        throw new Error("Bad Request");
      }
      mockDb.groups[index] = {
        ...mockDb.groups[index],
        statusId: MockDb.STATUS_LIST[0].value,
        status: MockDb.STATUS_LIST[0].name,
        confirmDate: "",
      };
      return mockDb.groups[index];
    }

    /* グループ一覧の納期確定 */
    pattern = appConfig.API_URL.BIZ_GROUPS_CONFIRM_DELIVERY.replace("{groupId}", "(\\d+)");
    match = url.match(new RegExp(`^${pattern}$`));
    if (match) {
      const groupId = Number(match[1]);
      // 納期回答算出済み以外納期確定できない
      const index = mockDb.groups.findIndex(
        (item) => item.groupId === groupId && item.statusId === "2"
      );

      if (index === -1) {
        throw new Error("Bad Request");
      }
      mockDb.groups[index] = {
        ...mockDb.groups[index],
        statusId: MockDb.STATUS_LIST[2].value,
        status: MockDb.STATUS_LIST[2].name,
        confirmDate: "",
      };
      return mockDb.groups[index];
    }

    throw new Error("Unknown PUT " + url);
  }

  async delete(url) {
    /* グループ一覧のグループ削除 */
    const match = url.match(new RegExp(`^${appConfig.API_URL.BIZ_GROUPS}/(\\d+)$`));
    if (match) {
      const groupId = Number(match[1]);
      const index = mockDb.groups.findIndex((item) => item.groupId === groupId);
      if (index === -1) {
        throw new Error("Bad Request");
      }

      mockDb.ungroupRequests.forEach((item) => {
        if (item.groupId === groupId) {
          item.groupId = null;
        }
      });

      const removed = mockDb.groups.splice(index, 1)[0];
      return removed;
    }
    throw new Error("Unknown DELETE " + url);
  }
}
